import { intl } from '@fullstory/intl';
import { useMounted } from '@fullstory/react-hooks';
import { Params, Route } from '@fullstory/routes';
import React from 'react';
import { matchPath, Prompt } from 'react-router-dom';

interface NavigationPromptProps {
  allowedRoutes: Route<string, Params>[];
  blockTransition: boolean;
  message?: string;
}
export const NavigationPrompt: React.FC<NavigationPromptProps> = ({
  allowedRoutes,
  blockTransition,
  message = intl.formatMessage({
    defaultMessage: 'Changes you made may not be saved.',
    id: 'Saevsv',
  }),
}) => {
  const isMounted = useMounted();

  return (
    <Prompt
      data-component="NavigationPrompt"
      when={blockTransition && isMounted()}
      message={location => {
        const pathname = location?.pathname ?? location;
        const matchesAllowList = allowedRoutes.some(route => matchPath(pathname, route.path));

        // if it's any of these routes, allow the transition
        if (matchesAllowList) return true;
        // otherwise, deny and show the confirmation message
        return message;
      }}
    />
  );
};
